module.exports = __webpack_public_path__ + "static/media/26.4726223f.png";


//////////////////
// WEBPACK FOOTER
// ./src/layers/male/accessoires/26.png
// module id = 1132
// module chunks = 0